import { useState } from "react";
// import { Link } from "react-router-dom";
// import { useSchoolDetailsContext } from "../context/SchoolDetailsContext";
import { useLoader } from "../context/LoaderContext";
import { dynamicSuccess, failed } from "../hooks/useToast";
import axios from "axios";
import { headers } from "../exports/exports";
import { useAllDataContext } from "../context/AllDataContext";

const ContactInner = (props) => {
  const { setLoading } = useLoader();
  const { contactHeaderData } = props;
  const { allData } = useAllDataContext();
  const joinCommunityHeaderData = allData.joinCommunityHeaderData;
  // const { schoolDetailsData } = useSchoolDetailsContext();
  const [name, setName] = useState();
  const [email, setEmail] = useState();
  const [phone, setPhone] = useState();
  const [message, setMessage] = useState();
  const [errors, setErrors] = useState({});

  const isValidEmail = (email) => /\S+@\S+\.\S+/.test(email);
  const validateStep = () => {
    let newErrors = {};
    if (!email) newErrors.email = "Email is required";
    else if (!isValidEmail(email)) newErrors.email = "Invalid email format";

    if (!name) newErrors.name = "Name is required";
    if (!phone) {
      newErrors.phone = "Phone Number is required";
    } else if (!/^\d{10}$/.test(phone)) {
      newErrors.phone = "Invalid Phone Number";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = () => {
    if (!validateStep()) {
      return;
    }
    setLoading(true);
    try {
      const data = {
        data: {
          Name: name,
          Email: email,
          Phone: String(phone),
          Message: message,
        },
      };
      axios
        .post(
          `${process.env.REACT_APP_strapiUrl}/api/ega-contact-messages`,
          data,
          {
            headers: headers,
          },
        )
        .then(() => {
          setLoading(false);
          dynamicSuccess("Form submitted successfully!");
          setName("");
          setEmail("");
          setPhone("");
          setMessage("");
          setErrors({});
        })
        .catch(() => {
          setLoading(false);
          failed();
        });
    } catch (e) {
      setLoading(false);
      failed();
    }
  };

  return (
    <>
      <section className="contact pt-120">
        <div className="container">
          <div className="section-heading text-center" id="contactheader">
            <div className="flex-align d-inline-flex gap-8 mb-16">
              <span className="text-main-600 text-2xl d-flex">
                <i className="ph-bold ph-book-open" />
              </span>
              <h5 className="text-main-600 mb-0">
                {contactHeaderData[0]?.snippet}
              </h5>
            </div>
            <h2 className="mb-24">{contactHeaderData[0]?.title}</h2>
            <p className="">{contactHeaderData[0]?.description}</p>
          </div>
          {/* <div className="row gy-4" id="contactinfo">
            <div className="col-xl-4 col-md-6">
              <div className="contact-item bg-main-25 border border-neutral-30 rounded-12 px-32 py-40 d-flex align-items-start gap-24 hover-bg-main-600 transition-2 hover-border-main-600">
                <span className="contact-item__icon w-60 h-60 text-32 flex-center rounded-circle bg-main-600 text-white flex-shrink-0">
                  <i className="ph ph-map-pin-line" />
                </span>
                <div className="flex-grow-1">
                  <h4 className="mb-12">Address</h4>
                  <p className="text-neutral-500">
                    {schoolDetailsData[0]?.attributes?.Address}
                  </p>
                  <Link
                    to={schoolDetailsData[0]?.attributes?.Google_Map_Location}
                    className="text-main-600 fw-semibold text-decoration-underline mt-16"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Find Location
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-xl-4 col-md-6">
              <div className="contact-item bg-main-25 border border-neutral-30 rounded-12 px-32 py-40 d-flex align-items-start gap-24 hover-bg-main-600 transition-2 hover-border-main-600">
                <span className="contact-item__icon w-60 h-60 text-32 flex-center rounded-circle bg-main-600 text-white flex-shrink-0">
                  <i className="ph ph-envelope-open" />
                </span>
                <div className="flex-grow-1">
                  <h4 className="mb-12">Email Address</h4>
                  <p className="text-neutral-500">
                    {schoolDetailsData[0]?.attributes?.Email}
                  </p>
                  <a
                    href={`mailto:${schoolDetailsData[0]?.attributes?.Email}`}
                    className="text-main-600 fw-semibold text-decoration-underline mt-16"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Get In Touch
                  </a>
                </div>
              </div>
            </div>
            <div className="col-xl-4 col-md-6">
              <div className="contact-item bg-main-25 border border-neutral-30 rounded-12 px-32 py-40 d-flex align-items-start gap-24 hover-bg-main-600 transition-2 hover-border-main-600">
                <span className="contact-item__icon w-60 h-60 text-32 flex-center rounded-circle bg-main-600 text-white flex-shrink-0">
                  <i className="ph ph-phone-call" />
                </span>
                <div className="flex-grow-1">
                  <h4 className="mb-12">Phone Number</h4>
                  <p className="text-neutral-500">
                    {schoolDetailsData[0]?.attributes?.Phone_Number1}
                  </p>
                  <p className="text-neutral-500">
                    {schoolDetailsData[0]?.attributes?.Phone_Number2}
                  </p>
                  <a
                    href={`tel:${schoolDetailsData[0]?.attributes?.Phone_Number1}`}
                    className="text-main-600 fw-semibold text-decoration-underline mt-16"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Contact Us Today!
                  </a>
                </div>
              </div>
            </div>
          </div> */}
        </div>
      </section>
      <section
        className="contact-form-section py-120  bg-main-25 position-relative z-1"
        id="contactform"
      >
        <img
          src="assets/images/bg/wave-bg.png"
          alt=""
          className="position-absolute top-0 start-0 w-100 h-100 z-n1 d-lg-block d-none"
        />
        <div className="container">
          <div className="row gy-5 align-items-center">
            {/* <div className="col-xl-7 col-lg-6 pe-lg-5">
              <div className="mb-40 md-xl-5">
                <div className="flex-align d-inline-flex gap-8 mb-16">
                  <span className="text-main-600 text-2xl d-flex">
                    <i className="ph-bold ph-book-open" />
                  </span>
                  <h5 className="text-main-600 mb-0">
                    {contactFormHeaderData[0]?.snippet}
                  </h5>
                </div>
                <h2 className="mb-24">{contactFormHeaderData[0]?.title}</h2>
                <p className="text-neutral-500 text-line-3 max-w-636">
                  {contactFormHeaderData[0]?.description}
                </p>
              </div>
              <div className="flex-align gap-40 flex-wrap">
                <div className="enrolled-students mt-12 d-block">
                  <img
                    src="assets/images/thumbs/enroll-student-img1.png"
                    alt=""
                    className="w-48 h-48 rounded-circle object-fit-cover transition-2"
                  />
                  <img
                    src="assets/images/thumbs/enroll-student-img2.png"
                    alt=""
                    className="w-48 h-48 rounded-circle object-fit-cover transition-2"
                  />
                  <img
                    src="assets/images/thumbs/enroll-student-img3.png"
                    alt=""
                    className="w-48 h-48 rounded-circle object-fit-cover transition-2"
                  />
                  <img
                    src="assets/images/thumbs/enroll-student-img4.png"
                    alt=""
                    className="w-48 h-48 rounded-circle object-fit-cover transition-2"
                  />
                  <img
                    src="assets/images/thumbs/enroll-student-img5.png"
                    alt=""
                    className="w-48 h-48 rounded-circle object-fit-cover transition-2"
                  />
                  <img
                    src="assets/images/thumbs/enroll-student-img6.png"
                    alt=""
                    className="w-48 h-48 rounded-circle object-fit-cover transition-2"
                  />
                </div>
                <div className="">
                  <ul className="flex-align gap-4 mb-10">
                    <li className="text-warning-600 text-2xl d-flex">
                      <i className="ph-fill ph-star" />
                    </li>
                    <li className="text-warning-600 text-2xl d-flex">
                      <i className="ph-fill ph-star" />
                    </li>
                    <li className="text-warning-600 text-2xl d-flex">
                      <i className="ph-fill ph-star" />
                    </li>
                    <li className="text-warning-600 text-2xl d-flex">
                      <i className="ph-fill ph-star" />
                    </li>
                    <li className="text-warning-600 text-2xl d-flex">
                      <i className="ph-fill ph-star-half" />
                    </li>
                  </ul>
                  <span className="text-neutral-700 fw-medium">
                    {" "}
                    2.5k+ reviews (4.95 of 5)
                  </span>
                </div>
              </div> 
            </div> */}

            <div className="col-lg-6">
              <div className="join-community__thumb text-end position-relative">
                <img
                  src={
                    joinCommunityHeaderData[0]?.image[0]?.media?.url &&
                    `${process.env.REACT_APP_cmsUrl}${joinCommunityHeaderData[0]?.image[0]?.media?.url}`
                  }
                  alt="join-community-img"
                  className="wow bounceIn"
                  data-tilt=""
                  data-tilt-max={12}
                  data-tilt-speed={500}
                  data-tilt-perspective={5000}
                  data-tilt-full-page-listening=""
                />
                {/* <div className="offer-message style-two px-24 py-12 rounded-12 bg-white fw-medium flex-align d-inline-flex gap-16 box-shadow-lg animation-upDown">
                    <span className="banner-box__icon flex-shrink-0 w-48 h-48 bg-purple-400 text-white text-2xl flex-center rounded-circle">
                      <i className="ph-bold ph-users" />
                    </span>
                    <div className="text-start">
                      <h6 className="mb-4">56K</h6>
                      <span className="">All Students</span>
                    </div>
                  </div> */}
              </div>
            </div>

            <div className="col-lg-6">
              <div className="p-24 bg-white rounded-12 box-shadow-md">
                <div className="border border-neutral-30 rounded-8 bg-main-25 p-24">
                  <div>
                    <h4 className="mb-0">Get In Touch</h4>
                    <span className="d-block border border-neutral-30 my-24 border-dashed" />
                    <div className="mb-24">
                      <label
                        htmlFor="name"
                        className="text-neutral-700 text-lg fw-medium mb-12"
                      >
                        Name{" "}
                      </label>
                      <input
                        type="text"
                        className={`common-input rounded-pill border-transparent focus-border-main-600 ${
                          errors.name && "error-border"
                        }`}
                        id="name"
                        placeholder="Enter Name..."
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                      />
                      {errors.name && (
                        <p className="error-message">{errors.name}</p>
                      )}
                    </div>
                    <div className="mb-24">
                      <label
                        htmlFor="email"
                        className="text-neutral-700 text-lg fw-medium mb-12"
                      >
                        Email{" "}
                      </label>
                      <input
                        type="email"
                        className={`common-input rounded-pill border-transparent focus-border-main-600 ${
                          errors.email && "error-border"
                        }`}
                        id="email"
                        placeholder="Enter Email..."
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                      {errors.email && (
                        <p className="error-message">{errors.email}</p>
                      )}
                    </div>
                    <div className="mb-24">
                      <label
                        htmlFor="phone"
                        className="text-neutral-700 text-lg fw-medium mb-12"
                      >
                        Phone{" "}
                      </label>
                      <input
                        type="number"
                        className={`common-input rounded-pill border-transparent focus-border-main-600 ${
                          errors.phone && "error-border"
                        }`}
                        id="phone"
                        placeholder="Enter Your Number..."
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)}
                        onWheel={(e) => e.target.blur()}
                      />
                      {errors.phone && (
                        <p className="error-message">{errors.phone}</p>
                      )}
                    </div>
                    <div className="mb-24">
                      <label
                        htmlFor="desc"
                        className="text-neutral-700 text-lg fw-medium mb-12"
                      >
                        Message
                      </label>
                      <textarea
                        id="desc"
                        className={`common-input rounded-24 border-transparent focus-border-main-600 h-110 ${
                          errors.message && "error-border"
                        }`}
                        placeholder="Enter Your Message..."
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                      />
                      {errors.message && (
                        <p className="error-message">{errors.message}</p>
                      )}
                    </div>
                    <div className="mb-0">
                      <button
                        type="submit"
                        className="btn btn-main rounded-pill flex-center gap-8 mt-40"
                        onClick={() => {
                          handleSubmit();
                        }}
                      >
                        Send Message
                        <i className="ph-bold ph-arrow-up-right d-flex text-lg" />
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ContactInner;
